// extracted by mini-css-extract-plugin
export default {"content":"styles_content__dRX2C","pendingWrapper":"styles_pendingWrapper__uoBtR","pending":"styles_pending__7tr0W"};